interface PreviewDocumentApprovalState {
  isSimReqAttachment: boolean;
  approved: boolean;
}

/**
 * A sim request attachment must be approved (not merely viewed) before the
 * prescription / plan aim can be submitted. `approved` reflects the editable
 * document's confirmed state from the latest preview fetch. Submission isn't
 * blocked outright — when this is true, submitting shows a confirmation modal
 * (see validateAutoDocs). Returns false when there is no sim request attachment
 * present, so the gate only applies when such a document actually exists.
 */
export const hasUnapprovedSimReqAttachment = (previewDocuments: PreviewDocumentApprovalState[] | undefined): boolean =>
  (previewDocuments ?? []).some((doc) => doc.isSimReqAttachment && !doc.approved);

/**
 * Submission must never proceed before the preview documents have loaded: until
 * then the unapproved-attachment / unviewed-autodoc state isn't known, so an early
 * Plan Aim / Prescription click would bypass the confirmation gate. Both the
 * submit-button disabled state and validateAutoDocs use this so the two stay in
 * sync. Ready only when the query has finished loading AND returned data.
 */
export const isSubmissionPreviewReady = (previewDataLoading: boolean, submissionPreviewData: unknown): boolean =>
  !previewDataLoading && submissionPreviewData != null;
